export default function (shape) {
    var attrs = shape.attr();
    var x = attrs.x, y = attrs.y, width = attrs.width, height = attrs.height;
    return {
        x: x,
        y: y,
        width: width,
        height: height,
    };
}
//# sourceMappingURL=rect.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g-base/esm/bbox/rect.js
// module id = null
// module chunks = 